import React from "react";
import TeaLoadingModal from "../../teaLoadingModal/TeaLoadingModal";

const StatusPopup = ({ open, onClose }) => {
  return (
    <TeaLoadingModal
      open={open}
      onClose={onClose}
      message={"We're working on your post — till then,\nhave a cup of tea."}
    />
  );
};

export default StatusPopup;
